export default (state = {}, action = {}) => (
	action.type === 'LISTING' ? {
		...state,
		[action.listing]: {
			...action.data,
		},
	} : state
);
